import React from "react";
import { Link } from "react-router-dom";
import style from "./Footer.module.css";
import Logo from "../../assets/Infologo.png";
import Fb from "../../assets/fbLogo.png";
import Ig from "../../assets/igLogo.png";
import X from "../../assets/xLogo.png";

function Footer() {
  return (
    <footer>
      <div className={style.top}>
        <div className={`${style.content} ${style.left}`}>
          <div className={style.sect2}>
            <img src={Logo} alt="" width="200px" height="auto" />
            <div className={style.sectionItems}>
              <div className={style.sectionItemLeft}>
                <Link to="https://www.facebook.com/">
                  {" "}
                  <img src={Fb} alt="fb" />
                </Link>
                <Link to="https://www.instagram.com/msigmainfotech/">
                  {" "}
                  <img src={Ig} alt="ig" />
                </Link>
                <Link to="https://www.x.com/">
                  {" "}
                  <img src={X} alt="x" />
                </Link>
              </div>
            </div>
          </div>
        </div>
        <div className={style.pages}>
          <ul>
            <div className={style.sectionHeading}>QUICK LINKS</div>
            <div className={style.sectionItems}>
              <div>
                <li>
                  <Link to="/">Home</Link>
                </li>
                <li>
                  <Link to="/About">About Us</Link>
                </li>
                <li>
                  <Link to="/Services">Services</Link>
                </li>
              </div>
              <div>
                <li>
                  <Link to="/LnD">LnD</Link>
                </li>
                <li>
                  <Link to="/Career">Career</Link>
                </li>
                {/* <li>
                  <Link to="/Blogs">Blogs</Link>
                </li> */}
              </div>
            </div>
          </ul>

          <ul>
            <div className={style.sectionHeading}>TRAINING</div>

            <li>
              <Link to="/">Corporate Training</Link>
            </li>
            <li>
              <Link to="/">Offline Training</Link>
            </li>
            <li>
              <Link to="/">Online Training</Link>
            </li>
          </ul>

          <ul>
            <div className={style.sectionHeading}>CONNECT US</div>
            <li>
              <a href="tel:+91 94004 09422">+91 94004 09422</a>
            </li>
            <li>
              <a href="mailto:rasulkhanf.msigmagokulam@gmail.com">
                rasulkhanf.msigmagokulam@gmail.com
              </a>
            </li>
            <li>
              <Link
                to="https://maps.app.goo.gl/wa9AABkM9T4b1Kcv8"
                target="_blank"
              >
                Msigma Infotech, HMR Layout, Gokula Extension, Mathikere{" "}
                <br></br>
                Bengaluru, Karnataka 560054{" "}
              </Link>
            </li>
          </ul>
        </div>
      </div>

      <div className={style.info}>
        <div className={style.legal}>
          <Link to="/">Terms & Conditions</Link>
          <Link to="/">Privacy Policy</Link>
        </div>
        <div className={style.copyright}>
          © 2024 Msigma Infotech Ltd. All rights reserved
        </div>
      </div>
    </footer>
  );
}

export default Footer;
